<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-page-header @back="goBack" :content="'结算对账单'"></el-page-header>
        <el-form label-position="right" :model="item" label-width="auto">

            <el-form-item label="对账单编号">
                <el-input v-model="item.number" placeholder="请输入对账单编号"></el-input>
            </el-form-item>
            <el-form-item label="对账单金额">
                <el-input v-model="item.fee" placeholder="请输入对账单金额"></el-input>
            </el-form-item>
            <el-form-item label="状态">
                <el-radio v-model="status" label="1">待结算</el-radio>
                <el-radio v-model="status" label="2">已结算</el-radio>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                item: {},
                isLoad: false,
                id: this.$route.query.id,
                options: [
                    {
                        id: '1',
                        name: '蒙牛集团'
                    }, {
                        id: '2',
                        name: 'gongys'
                    }, {
                        id: '3',
                        name: '厦门点微信息'
                    }, {
                        id: '4',
                        name: '软件园独家代理'
                    }],
                status: '2'
            }
        },
        created() {
            this.item = {
                id: 1,
                industryId: 1,
                name: '蒙牛集团',
                number: '1',
                fee: '100.00'
            }
            // this.loadData()
        },
        methods: {
            loadData: function () {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
                this.axios.post('industry/list', {}).then(res => {
                    res.data.records.forEach((item) => {
                        this.options.push(item)
                    })
                }).then(res => {
                    if (this.id) {
                        return this.axios.post('industry/template/detail', {
                            id: this.id
                        })
                    }
                }).then(res => {
                    this.isLoad = !this.isLoad
                    if (res) {
                        // item是基础信息
                        this.item = res.data
                    }
                }).catch(() => {
                    this.isLoad = !this.isLoad
                })
            },
            // 后退一步
            goBack() {
                this.$router.back(-1)
            },
            // 提交
            submit() {
                return;
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
                let url = ''
                if (this.id) {
                    url = 'industry/template/update'
                    this.item.id = this.id
                } else {
                    url = 'industry/template/add'
                }
                this.axios.post(url, this.item)
                    .then(() => {
                        this.isLoad = !this.isLoad
                        this.$message.success({
                            message: '保存成功'
                        });
                        this.goBack()
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
            uploadError() {
                this.$message.error({
                    message: '上传失败'
                });
            }
        }
    }
</script>
<style scoped>
</style>·